export default __webpack_public_path__ + "static/media/WNo.8-13.9175be57.jpg";